export default {"src":"/_next/static/media/99-300x164.e172d929.svg","height":48,"width":112,"blurWidth":0,"blurHeight":0};